import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';

// CONSTANTS
import { ROUTE_START } from '@/constants/routes';
import { LOCATIONS_HOME_PARTNER_PAGE } from '@/constants/locations';

// UTILITY
import { externalLink, getExternalUrlParams } from '@/utility/analytics';
import { updateUrl } from '@/utility/common';
import { checkIsAbsoluteUrl } from '@/utility/routes';

// COMPONENTS
import Link from '@/components/Link';

// STYLES
import { Container } from './styles';

const CordCutting = () => {
  const [t] = useTranslation();

  const { unique_id, partner, textOverwrites } = useSelector(({ auth, partner: partnerStore }) => ({
    unique_id: auth.unique_id,
    partner: partnerStore.data,
    textOverwrites: partnerStore.data?.text_overwrites || {},
  }));
  const analyticsLocation = LOCATIONS_HOME_PARTNER_PAGE;

  const features = [
    {
      title:
        textOverwrites.partner_home_cordcut_feature1_title ||
        t('partnerHome.cordCutting.features.item1.title'),
      subtitle:
        textOverwrites.partner_home_cordcut_feature1_subtitle ||
        t('partnerHome.cordCutting.features.item1.subtitle'),
      url: textOverwrites.partner_home_cordcut_feature1_url || ROUTE_START,
      btn_name: textOverwrites.partner_home_cordcut_feature1_button_text || t('buttons.getStarted'),
    },
    {
      title:
        textOverwrites.partner_home_cordcut_feature2_title ||
        t('partnerHome.cordCutting.features.item2.title'),
      subtitle:
        textOverwrites.partner_home_cordcut_feature2_subtitle ||
        t('partnerHome.cordCutting.features.item2.subtitle'),
      url: textOverwrites.partner_home_cordcut_feature2_url || partner.home_link || '',
      btn_name: textOverwrites.partner_home_cordcut_feature2_button_text || t('buttons.signUp'),
    },
  ];

  function handleExternalLinkClicked(href) {
    externalLink({ href, location: analyticsLocation });
  }

  function getLink(link, name) {
    if (!link) return null;

    const externalUrlParams = getExternalUrlParams({ unique_id });
    const href = updateUrl(link, externalUrlParams);
    const isExternalLink = checkIsAbsoluteUrl(href);
    let btnProps = {
      component: Link,
      to: href,
    };

    if (isExternalLink) {
      btnProps = {
        component: 'a',
        href,
        target: '_blank',
        onClick: () => handleExternalLinkClicked(href),
      };
    }

    return (
      <Grid item xs={12} sm="auto">
        <Button className="feature__btn" color="primary" location={analyticsLocation} {...btnProps}>
          {name}
        </Button>
      </Grid>
    );
  }

  return (
    <Container className="cord-cutting section section--grey">
      <div className="page-content">
        <Typography className="m-b-25" variant="h3" align="center">
          {t('partnerHome.cordCutting.title')}
        </Typography>
        <Typography className="cord-cutting__subtitle p3" align="center">
          {t('partnerHome.cordCutting.subtitle')}
        </Typography>
        <Grid container spacing={3}>
          {features.map((item, idx) => (
            <Grid item xs={12} key={idx}>
              <Paper className="feature">
                <Grid container spacing={2}>
                  <Grid item>
                    <Typography className="feature__number" variant="h3" component="p">
                      {idx + 1}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={10} md={4}>
                    <Typography className="feature__title" variant="h4">
                      {item.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm>
                    <Typography className="feature__subtitle p3">{item.subtitle}</Typography>
                  </Grid>
                  {!!item.url && getLink(item.url, item.btn_name)}
                </Grid>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </div>
    </Container>
  );
};

export default React.memo(CordCutting);
